$(document).ready(function () {
  if ($('.filter').length) {
    $('.filter--menu--item-js').click(function (event) {
      event.preventDefault();
      var filter = $(this).attr('data-filter');

      if (filter == 'all') {
        $('.filter--menu--item-js').removeClass('is-open');
        $(this).addClass('is-open');

        $('.benefits--item')
          .removeClass('is-open benefits--item--hide-init-anim')
          .fadeOut();
        $('.benefits--item').addClass('is-open');
      } else {
        $('.filter--menu--item-js').removeClass('is-open');
        $(this).addClass('is-open');

        $('.benefits--item')
          .removeClass('is-open benefits--item--hide-init-anim')
          .fadeOut();
        $('.benefits--item[data-category="' + filter + '"]').addClass(
          'is-open'
        );
      }
    });
  }
});
